import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles/MyClassroomsHeader.module.css';
import CreateClassroomModal from './CreateClassroomModal';
import { ClassroomContext } from '../../context/ClassroomContext';
import AuthContext from '../../context/AuthContext';
import { useActiveClassroomId, useIsCalendarPage } from './classroomPaths';
const MyClassroomsHeader = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { classroom } = useContext(ClassroomContext);
    const { user } = useContext(AuthContext);
    const [classroomName, setClassroomName] = useState(null);
    const navigate = useNavigate();

    const activeClassroomId = useActiveClassroomId();
    const isCalendarPage = useIsCalendarPage();

    useEffect(() => {
        if (activeClassroomId && classroom) {
            setClassroomName(classroom.name);
        } else {
            setClassroomName(null);
        }
    }, [activeClassroomId, classroom]);

    const handleClassroomCreated = (classroomId) => {
        if (classroomId) {
            navigate(`/my-classrooms/${classroomId}/d`);
        }
        setIsModalOpen(false); 
    };

    return (
        <>
            {isModalOpen && (
                <CreateClassroomModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onClassroomCreated={handleClassroomCreated}
                />
            )}
            <div className={styles.headerContainer}>
                <h3 className={styles.title}>{classroomName || (isCalendarPage ? 'Calendar' : 'Classrooms')}</h3>
                <button
                    className={styles.createClassroomButton}
                    disabled={user.tier === 0}
                    onClick={() => setIsModalOpen(true)}
                >
                    Create Classroom
                </button>
            </div>
        </>
    );
};

export default MyClassroomsHeader;
